import * as React from "react";

function SvgCopyClipboard(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return <svg viewBox="0 0 16 16" ref={svgRef} {...props}><path d="M5.533 2.345v1.42h4.934v-1.42H9a1.06 1.06 0 10-2 0zm-3.06 8.245h4.284v1.847a.127.127 0 00.225.082l2.544-3.053V9.3L6.982 6.25a.127.127 0 00-.225.081v1.848H2.473V3.051a.939.939 0 01.94-.932H4.62a.942.942 0 01.913-.706h.558a2 2 0 013.818 0h.558a.937.937 0 01.913.706h1.207a.935.935 0 01.94.932v12.017a.939.939 0 01-.94.932H3.413a.935.935 0 01-.94-.932z" fill="currentColor" /></svg>;
}

const ForwardRef = React.forwardRef(SvgCopyClipboard);
export default ForwardRef;